import { store } from '../index'

function loginAct(token) {
    return {
        type: "SET_TOKEN",
        token
    }
}

export const login = (token) => {
    return store.dispatch(loginAct(token))
}